import React from "react";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import fotterimg from "../Assets/tit-logo-w.webp";
import { FaGithub } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";

const OurFooter = () => {
  return (
    <footer>
      <div className="footerBG">
        <div className="footer-container">
          <div className="footer-content">
            <img src={fotterimg} alt="" />
            <p>
              TIT Technocrats Group of Institutions Anand Nagar, BHEL Opposite
              Hathaikheda Dam, Bhopal, Madhya Pradesh 462021
            </p>
          </div>
          <div className="footer-nav">
            <ul>
              <li>
                <MdKeyboardDoubleArrowRight />
                <a href="#About">About Us</a>
              </li>
              <li>
                <MdKeyboardDoubleArrowRight />
                <a href="#advisory">Advisory Board</a>
              </li>
              <li>
                <MdKeyboardDoubleArrowRight />
                <a href="#OurTeam">Our Team</a>
              </li>
              <li>
                <MdKeyboardDoubleArrowRight />
                <a href="#inst">Institutes</a>
              </li>
              <li>
                <MdKeyboardDoubleArrowRight />
                <a href="#programID">Programs</a>
              </li>
            </ul>
          </div>
          <div className="footer-nav">
            <ul>
              <li>
                <MdKeyboardDoubleArrowRight />
                <a href="#"> Student / Staff Login</a>
              </li>
              <li>
                <MdKeyboardDoubleArrowRight />
                <a href="#"> Events</a>
              </li>
              <li>
                <MdKeyboardDoubleArrowRight />
                <a href="#"> Career</a>
              </li>
              <li>
                <MdKeyboardDoubleArrowRight />
                <a href="#">Privacy Policy</a>
              </li>
              <li>
                <MdKeyboardDoubleArrowRight />
                <a href="https://technocratsgroup.edu.in/" target="_blank">Contact Us</a>
              </li>
            </ul>
          </div>
        </div>
        <hr class="accessory"></hr>

        <div className="footer-des">
          <p>
            Hello, my name is Vikash Verma. <br /> I developed this project
            using React.js to enhance my web development skills by cloning my
            college website. <br /> This project helped me sharpen my front-end
            development abilities and significantly boosted my confidence in
            creating responsive, functional, and visually appealing websites.
          </p>
        </div>
        <div className="footer-icons">
          <ul>
          
            <li>
              <a href="https://github.com/Vikashverma2" target="_blank">
                <FaGithub />
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/in/vikashverma2/" target="_blank">
                <FaLinkedinIn />
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/vikashverma04/" target="_blank">
                <FaInstagram />
              </a>
            </li>

            <li>
              <a href="https://www.facebook.com/Vikashverma0/" target="_blank">
                <FaFacebookF />
              </a>
            </li>
          </ul>
        </div>
     

      <div className="footer-credit">
      <p>
      © Copyright 2024 <a href="https://technocratsgroup.edu.in/" target="_blank">TIT Technocrats Group</a> . All Right Reserved. Designed by <a href="https://github.com/Vikashverma2" target="_blank">Vikash Verma</a> 
      </p>
      </div>

      </div>
    </footer>
  );
};
export default OurFooter;
